module.exports = __webpack_public_path__ + "static/home1-brand-carousel-9edd1fa4df08ac55600cafa1a9aa2d67.png";